import Modal from "react-native-modal";
import React, { useCallback, useRef, useState, useEffect, useLayoutEffect, forwardRef, useImperativeHandle } from 'react';
import { Platform, useWindowDimensions } from "react-native";
import styles from "@stylesheet";
import { Text, View } from "@constants/Themed";
import { BlurView } from "@react-native-community/blur";
import Button from "../../UI/Button/Button";
import { Title } from "@constants/Themed";
import parseByDelimiter from "@utils/parseByDelimiter";
import RowComponent from "../../Global/RowComponent/RowComponent";
import EmailComposeModal from "./EmailComposeModal/EmailCompose";
import * as Animatable from 'react-native-animatable';
import SvgQRCode from 'react-native-qrcode-svg';
import * as Linking from 'expo-linking';
import { themeSelector } from "@reduxLocal/selectors/themeSelector";
import { useNavigation } from "@react-navigation/native";

export type ActionModalHandle = {
  openModal: (item: {}) => void;
}

const ActionsModal = forwardRef<ActionModalHandle>((props, ref) => {
  const theme = themeSelector();  
  const [item, setItem] = useState({});
  const emailComposeRef = useRef(null);
  const { width, height } = useWindowDimensions();
  const [qrCode, setQrCode] = useState(false);
  const [qrValue, setQrValue] = useState(`smartsaas:/open?form/${item?.dataTitle}`);
  const handleOpenEmailCompose = useCallback(() => { emailComposeRef.current?.present() }, [emailComposeRef]);
  const navigation = useNavigation();
  const [visibleState, setState] = useState(false);
  const windowDimensions = useWindowDimensions();

  useImperativeHandle(ref, () => ({
    openModal: (item) => {
      setItem(item);
      setState(true);
    }
  }));


  useEffect(() => {
    if (emailComposeRef) {
      emailComposeRef.current?.expand();
    }
  }, [emailComposeRef]);

  const generateQR = useCallback(() => {
    const url = Linking.createURL(`/form/${item._id}`, { queryParams: { dataTitle: item.dataTitle } })
    setQrValue(url)
  }, [item]);

  return (
    <Modal
      isVisible={visibleState}
      animationIn={'zoomInDown'}
      animationOut={'zoomOutUp'}
      hasBackdrop={true}
      coverScreen={true}
      backdropColor="black"
      backdropOpacity={0.4}
      deviceHeight={windowDimensions.height}
      deviceWidth={windowDimensions.width}
      onBackdropPress={() => setState(false)}
      style={{ paddingTop: 50, marginBottom: -50, gap: 30 }}
    >
      <BlurView
        style={styles.blurViewStyle}
        blurAmount={10}

        reducedTransparencyFallbackColor="white"
        pointerEvents='none'
      />
      <View style={{ flex: 3, flexDirection: 'row', gap: 30, borderRadius: 20, padding: 20 }}>
        <Animatable.View direction={qrCode ? 'normal' : 'reverse'} transition={["flex"]} style={{ flex: qrCode ? 1 : 2, gap: 20 }}>
          <View style={{ borderRadius: 20, flex: 1, padding: 20, alignSelf: 'stretch', minHeight: '40%', overflow: 'hidden' }}>
          <View style={{ flex: 1, gap: 10 }}>
              <Title style={{ borderBottomWidth: 1 }}>Actions for {parseByDelimiter(item?.dataTitle || "")}</Title>
              <View style={{ height: 150 }}>
                <RowComponent
                  forceColumn={Platform.OS != 'web'}
                  title={"Edit Model"}
                  buttonText="Edit Model"
                  subtitle={"Make changes to your capture model"}
                  icon={"edit"}
                  onPress={() => {
                    navigation.navigate('Data', { screen: 'DataHandler', params: {id: `${item?._id.toString()}`} });
                    setState(false);
                  }}
                />
              </View>
            <View style={{ height: 150 }}>
              <RowComponent title={"Send group email"} buttonText="Send email" subtitle={"Quickly send personalised email to all stored contacts under a data model"} icon={"mail"}
                onPress={() => handleOpenEmailCompose()}
              />
            </View>
            <View style={{ height: 150 }}>
              <RowComponent title={"Send group WhatsApp"} buttonText="Send message" subtitle={"Quickly send personalised messages to all stored contacts under a data model"} icon={"phone"}
                onPress={() => alert('WhatsApp integration coming soon!')}
              />
            </View>
            <View style={{ height: 150 }}>
              <RowComponent title={"View QR Code"} buttonText="View QR Code" subtitle={"Allow anyone to quickly enter form data by sharing a QR code"} icon={"qrcode"}
                  onPress={() => { if (!qrCode) { generateQR() } setQrCode(!qrCode) }}
              />
            </View>
          </View>
        </View>
        </Animatable.View>
        {qrCode &&
          <Animatable.View direction={qrCode ? 'reverse' : 'normal'} transition={'flex'} style={{ borderRadius: 20, flex: qrCode ? 1 : 0, padding: 20, minHeight: '40%' }}>
            <Title>{parseByDelimiter(item?.dataTitle || "")}</Title>
            <Text>Easily share forms with anyone using the QR code below</Text>
            <View style={{ flex: 1, alignSelf: 'center', justifyContent: 'center', backgroundColor: "transparent" }}>
              <SvgQRCode size={200} value={qrValue} />
            </View>
          </Animatable.View>
          }
      </View>
      <Button buttonText={"Close"} customStyle={{ minHeight: 40, nmarginBottom: 10, flex: 1, }} textColor="white" defaultColor="red" onPress={() => setState(false)} customStyle={{ minWidth: 300 }} />
        <EmailComposeModal ref={emailComposeRef} />
    </Modal>
  )
})
export default ActionsModal;